import React from 'react';
import {
  BookOpen, Package, Boxes, Banknote, Building2, Percent, SlidersHorizontal,
  CalendarDays, BarChart3, Coins, Palette,
} from 'lucide-react';
import DashboardShortcut from './DashboardShortcut';

/**
 * COMPANY panel — compact 2-column grid of company-wide shortcuts.
 */
export default function CompanyPanel() {
  return (
    <section className="desk-panel">
      <header className="desk-panel-header">
        <span className="desk-panel-title">Company</span>
      </header>
      <div className="desk-shortcut-grid">
        <DashboardShortcut icon={BookOpen} label="Chart of Accounts" path="/accounts" />
        <DashboardShortcut icon={Package} label="Products & Services" path="/products" />
        <DashboardShortcut icon={Boxes} label="Inventory" path="/inventory" />
        <DashboardShortcut icon={Banknote} label="Order Checks" path="/banking" />
        <DashboardShortcut icon={Building2} label="Company Profile" path="/settings/company" />
        <DashboardShortcut icon={Palette} label="Theme & Branding" path="/settings/branding" />
        <DashboardShortcut icon={Percent} label="Tax Settings" path="/tax" />
        <DashboardShortcut icon={SlidersHorizontal} label="Accounting Preferences" path="/settings/company" />
        <DashboardShortcut icon={Coins} label="Currencies & Rates" path="/settings/currency" />
        <DashboardShortcut icon={CalendarDays} label="Calendar" path="/settings/fiscal" />
        <DashboardShortcut icon={BarChart3} label="Company Reports" path="/reports" />
      </div>
    </section>
  );
}
